export const dropdownMenuClassName = 'sdsm-dropdown';
